<template>
    <div class="ModalAccount">
        <LoginModal v-show="!isMobile || tab === 'login'" :isMobile="isMobile" @close="handleClose"
                    @changeTab="handleChangeTab"/>
        <div v-if="!isMobile" class="ModalAccount__separator">ou</div>
        <SignupModal v-show="!isMobile || tab === 'signup'" :isMobile="isMobile" @close="handleClose"
                     @changeTab="handleChangeTab"/>
    </div>
</template>

<script>
    import LoginModal from "./LoginModal";
    import SignupModal from "./SignupModal";
    import ModalBus from "../../../eventBus";

    export default {
        components: {LoginModal, SignupModal},
        data: function () {
            return {
                tab: 'login',
                isMobile: false
            }
        },
        methods: {
            handleChangeTab: function (tab) {
                this.tab = tab;
            },
            checkMobile: function () {
                this.isMobile = window.innerWidth <= 900 || window.innerHeight <= 600;
            },
            handleClose: function () {
                ModalBus.close();
            }
        },
        created() {
            window.addEventListener('resize', this.checkMobile);
            this.checkMobile();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkMobile);
        }
    }
</script>
